import { makeAccelerateExtension } from "./extension.js";
export function withAccelerate() {
    return makeAccelerateExtension(globalThis.fetch);
}
